const selectDropdown = (data, valueKey, labelKey) => {
  return data?.map((item) => {
    return { value: item[valueKey], label: item[labelKey] };
  });
};

export default selectDropdown;
